import { FC, useEffect, useRef, useState } from 'react';

import * as typeformEmbed from '@typeform/embed';
import { Col, Row } from 'antd';
import { config } from 'config/config';
import getConfig from 'next/config';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomModal from 'src/components/CustomModal';
import { ISurvey, IUser } from 'src/shared/models';
const { DEFAULT_LANGUAGE } = getConfig().publicRuntimeConfig;
interface ITypeform {
  user: IUser;
  showSurvey: boolean;
  surveyData: ISurvey;
  completeSurvey: () => Promise<void>;
}

const TypeformComponent: FC<ITypeform> = ({
  user,
  showSurvey,
  surveyData,
  completeSurvey,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { locale } = useIntl();
  const uuidUser = user.uuidUser;
  const { idUser, email } = user;

  const {
    idSurvey,
    idTypeform,
    score: { points },
  } = surveyData;

  const typeformRef = useRef(null);

  const handleSubmit = async () => {
    try {
      setModalVisible(true);
      setLoading(true);
      await completeSurvey();
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  useEffect(() => {
    typeformEmbed.createWidget(
      `${config.APP.TYPEFORM_URL}/${idTypeform}#user_id=${idUser}&survey_id=${idSurvey}`,
      {
        container: typeformRef.current,
        hideFooter: true,
        hideHeaders: true,
        onSubmit: handleSubmit,
        opacity: 0,
        hidden: {
          country: `${DEFAULT_LANGUAGE.trim().split('-').pop()}`,
          email: `${email}`,
          uuid_user: `${uuidUser}`,
        },
      },
    );
  }, [typeformRef]);

  const modalContent = (
    <Row justify="center" align="middle">
      <Col span={20}>
        <Row justify="center" align="middle">
          <div className="icon icon__size-120 icon--process-check" />
        </Row>
        <Row justify="center" className="block--small">
          <span className="finalize-title">
            <FormattedMessage id="page.challenge.survey.modal-success" />
          </span>
        </Row>
        {points && (
          <Row className="block--small regular-body" justify="center">
            <FormattedMessage
              id="page.challenge.survey.you-win-{points}-points"
              values={{
                points: Math.abs(Number(points || 0)).toLocaleString(locale),
              }}
            />
          </Row>
        )}
      </Col>
    </Row>
  );

  return (
    <>
      <div
        ref={typeformRef}
        style={
          showSurvey ? { width: '100%', height: '500px' } : { display: 'none' }
        }
      />
      <CustomModal
        {...{
          visible: modalVisible,
          loading,
          error,
          content: modalContent,
          onCancel: closeModal,
          footer: null,
          showIcon: false,
          customClass: 'quiz-modal-finalize',
        }}
      />
    </>
  );
};

export default TypeformComponent;
